import { Component, OnInit, ViewChild } from '@angular/core';
import { MainListViewComponent } from '@app/components/main-listview/main-listview.component';
import { ParentItemProviderService } from '@app/shared';

import {
  FilterView,
  FilterViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  UIComponents
} from '@ntap/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-spremiste-objekti',
  templateUrl: './spremiste-objekti.component.html',
  styleUrls: ['./spremiste-objekti.component.scss'],
  providers: [ParentItemProviderService]
})
export class SpremisteObjektiComponent
  extends MainListViewComponent
  implements OnInit
{
  override INIT_COMP_ID = UIComponents.LISTVIEW;

  @ViewChild(FilterViewProviderDirective)
  filterViewProvider: FilterViewProviderDirective<FilterView>;

  @ViewChild(ListViewProviderDirective)
  listViewProvider: ListViewProviderDirective<ListView>;

  filterSubscription: Subscription;

  data: Observable<string>;
  name: Observable<string>;
  arhivId: string;
  oznaka: string;
  naziv: string;
  posjednik: any;

  viewData$: Observable<any>;
  dataaa: string;

  override ngOnInit() {
    this.changeView('spremiste_objekti');
  }
}
